import React, { useState, useLayoutEffect } from 'react';

import { Parallax } from 'rc-scroll-anim';

import mainImgLeft1 from '@assets/images/persons/person-1.webp';

import mainImgRight1 from '@assets/images/persons/person-2.webp';

import { ReactComponent as Nature } from '@assets/images/icons/nature.svg';
import { ReactComponent as World } from '@assets/images/icons/world.svg';

type BlockInfoTypes = {
  headerLeft?: string;
  headerRight?: string;
  index?: number;
  isDesktopOrLaptop?: any;
  active?: boolean;
  onClick: (prop: boolean) => void;
};

export const Person: React.FC<BlockInfoTypes> = ({ children, ...props }) => {

  const {
    headerLeft,
    headerRight,
    // index,
    active,
    // onClick,
    isDesktopOrLaptop
  } = props;

  const showActive = (!isDesktopOrLaptop && active || isDesktopOrLaptop);
  const showNotActive = (!isDesktopOrLaptop && !active || isDesktopOrLaptop);

  return (
    <>
      <div
        className="
          max-w-1160
          mx-auto
          flex
          flex-col
          lg:flex-row
          justify-between
          w-full
          text-white
          rounded-2.5xl
          lg:pb-15
          mb-10
          lg:mb-0
          video-in-view-1
        "
      >

        {showNotActive &&<div className="pl-5 lg:pl-15 pr-5 flex-1 font-serif">
          <Parallax
            animation={{ y: 0, opacity: 1, playScale: [0.20, 0.50] }}
            style={{ transform: isDesktopOrLaptop ? 'translateY(-100px)' : 'translateY(-50px)', opacity: 0 }}
            className="flex-1"
          >
            <div className="flex-1 font-sans font-extrabold text-2xl lg:text-3xl leading-8.5 lg:leading-11">
              {!isDesktopOrLaptop && <div
                className="
                  flex
                  justify-between
                  mx-5
                  mb-7.5
                "
              >
                <div
                  className={`
                    bg-white
                    relative
                    inline-flex
                    justify-center
                    items-center
                    border
                    border-white
                    rounded-full
                    w-15
                    h-15
                    flex-shrink-0
                    z-10
                  `}
                >
                  <World
                    className={`
                      fill-current
                      text-smGrayText
                    `}
                    width={37}
                    height={37}
                  />
                </div>
              </div>}
              <h3 className="mb-3 lg:mb-8 text-redText">
                {headerLeft}
              </h3>
            </div>
          </Parallax>
          <div
            className="relative mb-5"
          >
            <a
              id="person-1-lab"
              href="https://iz.ru/1180484/anna-urmantceva/pervye-zarazheniia-mogli-byt-i-v-sentiabre-2019-go"
              target="_blank"
              className="
                w-full
                flex
                cursor-pointer
                z-10
                bg-redText
                rounded-2.5xl
                justify-center
                items-end
                min-h-177
                lg:min-h-291
                overflow-hidden
                hover-zoom
              "
            >
              <Parallax
                animation={{ y: 0, opacity: 1, playScale: [0.1, 0.35] }}
                style={{ transform: 'translateY(50px)', opacity: 0 }}
                className="relative top-0.5"
              >
                <img
                  className="transition duration-1000 origin-bottom ease-in-out"
                  src={mainImgLeft1}
                  width={isDesktopOrLaptop ? "466" : "279" }
                  height={isDesktopOrLaptop ? "282" : "158" }
                  alt=""
                />
              </Parallax>
            </a>
          </div>

          <h3 className="text-md font-bold mb-2.5">
            Юрий Дейгин
          </h3>
          <p className="text-md leading-6.5 mb-7.5">
            История лабораторной утечки коронавируса, рассказанная научным расследователем Юрием Дейгиным. Эксперт состоит в международной группе DRASTIC, объединившей людей по всему миру, которые ищут факты, касающиеся начала пандемии.
          </p>
          <a
            href="https://iz.ru/1180484/anna-urmantceva/pervye-zarazheniia-mogli-byt-i-v-sentiabre-2019-go"
            target="_blank"
            className="
              inline-flex
              border
              rounded-full
              px-6
              py-3
              transition
              hover:text-red-400
              hover:border-red-400
              main-btn
            "
          >Полное интервью</a>
        </div>}
        {showActive && <div className="pl-5 pr-5 lg:pr-15 flex-1 font-serif">
          <Parallax
            animation={{ y: 0, opacity: 1, playScale: [0.20, 0.50] }}
            style={{ transform: isDesktopOrLaptop ? 'translateY(-100px)' : 'translateY(-50px)', opacity: 0 }}
            className="flex-1"
          >
            <div className="flex-1 font-sans font-extrabold text-2xl lg:text-3xl leading-8.5 lg:leading-11">
            {!isDesktopOrLaptop && <div
                className="
                  flex
                  justify-between
                  mx-5
                  mb-7.5
                "
              >
                <div
                  className={`
                    bg-white
                    relative
                    inline-flex
                    justify-center
                    items-center
                    border
                    border-white
                    rounded-full
                    w-15
                    h-15
                    flex-shrink-0
                    z-10
                  `}
                >
                  <Nature
                    className={`
                      fill-current
                      text-smGrayText
                    `}
                    width={23}
                    height={36}
                  />
                </div>
              </div>}
              <h3 className="mb-3 lg:mb-8 text-greenText">
                {headerRight}
              </h3>
            </div>
          </Parallax>
          <div className="relative mb-5">
            <a
              id="person-1-nat"
              href="https://iz.ru/1186209/anna-urmantceva/v-blizhaishie-gody-v-prirode-naidut-istochnik-sars-cov-2"
              target="_blank"
              className="
                w-full
                flex
                cursor-pointer
                z-10
                bg-greenText
                rounded-2.5xl
                justify-center
                items-end
                min-h-177
                lg:min-h-291
                overflow-hidden
                hover-zoom
              "
              >
                <Parallax
                  animation={{ y: 0, opacity: 1, playScale: [0.1, 0.35] }}
                  style={{ transform: 'translateY(50px)', opacity: 0 }}
                  className="relative top-0.5"
                >
                  <img
                    className="transition duration-1000 origin-bottom ease-in-out"
                    src={mainImgRight1}
                    width={isDesktopOrLaptop ? "267" : "167" }
                    height={isDesktopOrLaptop ? "281" : "176" }
                    alt=""
                  />
                </Parallax>
            </a>
          </div>

          <h3 className="text-md font-bold mb-2.5">
            Александр Панчин
          </h3>
          <p className="text-md leading-6.5 mb-7.5">
            История возникновения коронавируса из природы, рассказанная биоинформатиком, старшим научным сотрудником Института проблем передачи информации имени А.А. Харкевича РАН Александром Панчиным. Эксперт доказательно опровергает факты, приводящиеся сторонниками версии лабораторной утечки.
          </p>
          <a
            href="https://iz.ru/1186209/anna-urmantceva/v-blizhaishie-gody-v-prirode-naidut-istochnik-sars-cov-2"
            target="_blank"
            className="
              inline-flex
              border
              rounded-full
              px-6
              py-3
              transition
              hover:text-red-400
              hover:border-red-400
              main-btn
            "
          >Полное интервью</a>
        </div>}
      </div>
    </>
  );
}